import ProjectsListPage from './ProjectsListPage.jsx';
import ProjectShowPage from './ProjectShowPage.jsx';

const COMPONENTS = {
  ProjectsListPage,
  ProjectShowPage,
};

export default COMPONENTS;
